import React, { ForwardRefExoticComponent } from "react";
import { IStyledComponent } from "styled-components";

import { Transformation } from "./types";

/**
 * React component wrapper to apply transformations to builder-supplied props. Transformations
 * translate builder props to native component props so that builder components can have a more
 * user-friendly interface.
 * @param Component React component
 * @param transformations a map of transformations
 * @returns a React component with transformations applied
 */
export const withTransformations = <P extends object, T extends object | null>(
  Component:
    | React.ComponentType<P & T>
    | IStyledComponent<"web", React.ComponentType<any>>
    | ForwardRefExoticComponent<any>,
  transformations?: Transformation<P, T>
) => {
  return React.forwardRef<any, P & T>((props, ref) => {
    const extras: Record<string, any> = {};

    if (transformations) {
      for (const key in transformations) {
        const transformation = transformations[key];
        if (transformation != null) {
          extras[key] = transformation(props);
        }
      }
    }
    return <Component {...props} {...extras} ref={ref} />;
  });
};
